const cursorOptions = [
  'auto',
  'default',
  'pointer',
  'alias',
  'all-scroll',
  'cell',
  'col-resize',
  'context-menu',
  'copy',
  'crosshair',
  'e-resize',
  'ew-resize',
  'grab',
  'grabbing',
  'help',
  'move',
  'n-resize',
  'ne-resize',
  'no-drop',
  'not-allowed',
  'ns-resize',
  'nw-resize',
  'nwse-resize',
  'progress',
  'row-resize',
  's-resize',
  'se-resize',
  'sw-resize',
  'text',
  'vertical-text',
  'w-resize',
  'wait',
  'zoom-in',
  'zoom-out'
];

export default cursorOptions;
